module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image15.1fd6e9e8.webp";